import React, { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { api, formatErr } from "@/lib/api";
import { PageHeader, StatCard } from "@/components/common";
import { Briefcase, FileText } from "lucide-react";
import PositionsPage from "@/pages/Positions";

export default function RecruiterHome() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ open_positions: 0, my_submissions: 0 });

  useEffect(() => {
    api.get("/recruiter/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <div className="px-8 pt-8 max-w-7xl mx-auto">
        <PageHeader
          testId="recruiter-home-header"
          title={`Welcome back, ${user.name.split(" ")[0]}`}
          subtitle="Browse open positions and submit your top candidates."
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-2">
          <StatCard testId="stat-open-positions" label="Open Positions" value={stats.open_positions} icon={Briefcase} />
          <StatCard testId="stat-my-submissions" label="My Submissions" value={stats.my_submissions} icon={FileText} />
        </div>
      </div>
      {/* embed positions table */}
      <PositionsPage />
    </div>
  );
}
